/**
 * Geçmiş cevaplar read model (GET /reply-examples, v0.1.38): the shop's own past replies
 * that mail-history took from the Sent folder and paired with the customer's question. The
 * Temsilci sees the most similar ones as examples; Sercan retires the wrong or stale ones here.
 */

import type { ReplyExample, ReplyExampleSource, ReplyExampleStatus, ReplyExamplesView } from '@twin/contracts';

export type { ReplyExample, ReplyExampleSource, ReplyExampleStatus, ReplyExamplesView } from '@twin/contracts';

export const REPLY_EXAMPLE_STATUS_LABELS: Readonly<Record<ReplyExampleStatus, string>> = Object.freeze({
  active: 'Etkin',
  retired: 'Emekli',
});

export const REPLY_EXAMPLE_SOURCE_LABELS: Readonly<Record<ReplyExampleSource, string>> = Object.freeze({
  gmail_sent: 'Gmail Gönderilmiş',
  claude_export: 'Sohbet dışa aktarımı',
  manual: 'Elle eklendi',
});

export const LANGUAGE_LABELS: Readonly<Record<string, string>> = Object.freeze({
  en: 'İngilizce',
  tr: 'Türkçe',
});

export function replyCountsOf(examples: readonly ReplyExample[]): ReplyExamplesView['counts'] {
  return {
    total: examples.length,
    active: examples.filter((item) => item.status === 'active').length,
    retired: examples.filter((item) => item.status === 'retired').length,
    paired: examples.filter((item) => item.paired).length,
    withProduct: examples.filter((item) => item.productId !== null).length,
  };
}

/** True when the example's subject, question, answer or product mentions every word of the query. */
export function matchesQuery(example: ReplyExample, query: string): boolean {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = [example.subject, example.question, example.answer, example.productTitle, example.productSku]
    .filter((part): part is string => typeof part === 'string')
    .join('\n')
    .toLowerCase();
  return words.every((word) => haystack.includes(word));
}
